/*
 * @Author: WangQiBiao
 * @Date: 2018-01-08 14:20:59
 * @Last Modified by: WangQiBiao
 * @Last Modified time: 2018-04-16 10:42:33
 */
import Command from '@/common/commands/index';
import Storages from './storages';
import { Message } from 'element-ui';
/**
 * 服务器地址
 */
export function serviceBaseUrl() {
  return window.PLATFORM_CONFIG.baseUrl;
}

/**
 * 设置Cookie用户信息
 *
 * @export
 * @param {any} res
 */
export function setUserCookieInfo(res) {
  if (res.u) {
    Storages.cookie.set('u', res.u);
  }
  if (res.t) {
    Storages.cookie.set('t', res.t);
  }
  if (res.v) {
    Storages.cookie.set('v', res.v);
  }
}
/**
 * 获取Cookie用户信息
 *
 * @export
 * @param {any} params
 * @returns
 */
export function getUserCookieInfo() {
  let cmdObj = {};
  if (Storages.cookie.get('u')) {
    cmdObj['u'] = Storages.cookie.get('u');
  }
  if (Storages.cookie.get('t')) {
    cmdObj['t'] = Storages.cookie.get('t');
  }
  if (Storages.cookie.get('v')) {
    cmdObj['v'] = Storages.cookie.get('v');
  }
  return cmdObj;
}
/**
 * 去登陆
 *
 * @export
 * @param {any} params
 */
export function goLogin(res) {
  if (res.indexOf('0x04') != -1 || res.indexOf('0x02') != -1) {
    //您的账号在别处上线，请重新登录
    var r = confirm('您的账号在别处登录？');
    if (r == true) {
      Storages.cookie.clear();
      window.location.href = '/login';
    }
  }
}
/**
 * 创建http请求
 *
 * @export
 * @param {any} params
 * @returns
 */
export function createHttpRequest(params) {
  //entry=入口，data=请求参数，methods=请求方式，sync=同步&异步
  params = Object.assign(
    {},
    { entry: '', data: {}, sync: true, methods: 'get', error: false },
    params,
  );
  return new Promise((resolve, reject) => {
    let cmd = new Command(params.entry);
    cmd.DEFAULT_CONFIG_PARAMS.config.baseUrl = serviceBaseUrl();
    Object.assign(cmd, params.data, getUserCookieInfo());
    cmd.success = function(res) {
      //账号是否在别处登录
      goLogin(res);
      let json_res = JSON.parse(res);
      if (json_res.state == 1) {
        setUserCookieInfo(json_res);
        resolve(json_res);
      } else {
        if (params.error) {
          Message.error(res.message);
        }
      }
    };
    cmd.ajax({
      sync: params.sync,
    });
  }).catch(err => {
    throw err;
  });
}
